import { useEffect, useState } from "react";
import Division from "./Division";
import "../../.csscode/App.css";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import "../../.csscode/TablePage.css";
import { toast } from "sonner";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const DivisionListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [density, setDensity] = useState("standard");
  const [loading, setLoading] = useState(false);
  const [divisionData, setDivisionData] = useState([{}]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [empData, setEmpData] = useState([{}]);
  const [showConfirm, setShowConfirm] = useState(false);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  useEffect(() => {
    fetchData();
    fetchEmployee();
  }, [refresh]);

  const fetchEmployee = async () => {
    setLoading(true);
    try {
      axios
        .get(apiUrl + "employee", { headers })
        .then((response) => {
          if (response.data.cd === 1) {
            setEmpData([{}]);
          } else {
            const sectionOption = response.data.map((op) => ({
              value: op.code,
              label: op.name,
            }));
            setEmpData(sectionOption);
          }
        })
        .catch((error) => {
          console.log("error " + error);
          setEmpData([{}]);
        });
    } catch (error) {
      setEmpData([{}]);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    axios.get(apiUrl + "division", { headers }).then((response) => {
      setDivisionData(response.data);
      setFilterData(response.data);
      setRefresh(false);
      setSelectedData("");
      setLoading(false);
      setLoading(false);
    });
  };

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();
    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setDivisionData(searchdata);
    } else {
      setDivisionData(filterData);
    }
    setSerach(getSearch);
  };

  const [addShow, setAddShow] = useState(false);
  const addHandleClose = () => {
    setShowConfirm(true);
  };
  const addHandleShow = () => setAddShow(true);

  const [editShow, setEditShow] = useState(false);
  const editHandleClose = () => {
    setShowConfirm(true);
  };
  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please select only one value");
      return;
    }
    setEditShow(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const exportToCSV = (data, filename) => {
    if (!data || data.length === 0) {
      toast.warning("No data available to export.");
      return;
    }

    const headers1 = ["ID", "Code", "Name", "Employee Name"];
    const rows = data.map((item) => {
      const emp = empData.find((e) => e.value === item.empcode);
      const empName = emp ? emp.label : item.empcode;
      return [item.id, item.code, item.name, empName];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers1, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Department"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Department"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Export to CSV"
                onClick={() => exportToCSV(divisionData, "departments")}
              >
                Export
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={(e) => handlesearch(e)}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            divisionData !== null &&
            divisionData.length > 0 &&
            Object.keys(divisionData[0]).length !== 0 &&
            divisionData
          }
          columns={columns}
          onSelectionModelChange={(itm) => setSelectedData(itm)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Department"
      >
        <Division
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          empData={empData}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Department"
      >
        <Division
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          empData={empData}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};
export default DivisionListing;
